import { Box, Typography } from "@mui/material";
import { RoundButton } from "../../../../../_styles/StyledButtons";
import { useTranslation, Trans } from "react-i18next";
import { useState } from "react";

interface Props {
    onConfirm: (exclude: boolean) => Promise<void>;
    onCancel: () => void;
}

export const ExcludeConfirmationModal = ({ onConfirm, onCancel }: Props) => {
    const { t } = useTranslation();
    const [loading, setIsLoading] = useState(false);

    const handleConfirm = async () => {
        setIsLoading(true);
        try {
            await onConfirm(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box>
            <Box>
                <Typography fontSize={14}>
                    <Trans i18nKey="DIALOG_EXCLUDE_STUDY_2ND_CONFIRMATION" />
                </Typography>
            </Box>
            <Box display="flex" justifyContent="flex-end" alignItems="center" mt={4}>
                <RoundButton
                    color="info"
                    variant="text"
                    sx={{ mr: 2 }}
                    onClick={onCancel}
                    disabled={loading}
                >
                    {t("GENERAL_NO")}
                </RoundButton>
                <RoundButton
                    color="error"
                    variant="text"
                    disabled={loading}
                    onClick={handleConfirm}
                >
                    {t("GENERAL_YES")}
                </RoundButton>
            </Box>
        </Box>
    );
};
